import MergeBuySideGroups from './MergeBuySideGroups.component';

export default MergeBuySideGroups;
